import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=fb2f4f94&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=fb2f4f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2f4f94",
  null
  
)

export default component.exports